import React, { Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { Table, TableBody } from '@material-ui/core';
import { graphql } from 'babel-plugin-relay/macro';
import { ErrorBoundary } from 'core';
import { isEmpty } from 'lodash';

import { TableMessagesProps, TableReminders } from 'embeds/deprecated/fragments';

import { ContentLoaderTableRows, TableHeadReminders, tableHeadRemindersCols } from 'embeds/components';

import {
  QueryTableRemindersEmbedQuery,
  QueryTableRemindersEmbedQueryVariables,
} from './__generated__/QueryTableRemindersEmbedQuery.graphql';

export interface QueryTableRemindersProps extends Omit<TableMessagesProps, 'classes' | 'fragmentRef'> {
  variables?: QueryTableRemindersEmbedQueryVariables;
}

const QueryTableReminders: React.FC<QueryTableRemindersProps> = ({ variables = {}, renderEmptyState, ...rest }) => {
  const data = useLazyLoadQuery<QueryTableRemindersEmbedQuery>(
    graphql`
      query QueryTableRemindersEmbedQuery($filter: FilterFindManyReminderInput) {
        ...TableReminders_EmbedQuery @arguments(filter: $filter)
      }
    `,
    variables,
    { fetchPolicy: 'network-only' },
  );

  return (
    <TableReminders fragmentRef={data} renderEmptyState={isEmpty(variables) ? renderEmptyState : undefined} {...rest} />
  );
};

export default (props: QueryTableRemindersProps) => (
  <ErrorBoundary>
    <Suspense
      fallback={
        <Table>
          <TableHeadReminders />
          <TableBody>
            <ContentLoaderTableRows colSpan={tableHeadRemindersCols} />
          </TableBody>
        </Table>
      }
    >
      <QueryTableReminders {...props} />
    </Suspense>
  </ErrorBoundary>
);
